import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, MenuItem, Select, styled, Typography } from '@mui/material';

const getTitleStyles = (theme, open) => {
  return {
    fontSize: '18px',
    fontWeight: 'bold',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: open
      ? theme.palette.colors.highlight
      : theme.palette.colors.onSecondaryAndDetailBackground,

    [theme.breakpoints.up('lg')]: {
      fontSize: '20px',
    },
  };
};

export const getPaperPropsStyles = (theme) => {
  return {
    backgroundColor: theme.palette.colors.primaryBackground,
    borderRadius: 0,
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    marginTop: '8px',
  };
};

export const MainContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'hasPadding' &&
    prop !== 'hasBackground' &&
    prop !== 'hasMarginBottom' &&
    prop !== 'backgroundColor',
})(({ theme, hasPadding, hasBackground, hasMarginBottom, backgroundColor }) => {
  const getBackground = () => {
    const radius = '5px';

    if (hasBackground)
      return {
        backgroundColor:
          backgroundColor || theme.palette.colors.secondaryBackground,
        borderTopLeftRadius: radius,
        borderTopRightRadius: radius,
      };

    return null;
  };

  return {
    marginBottom: hasMarginBottom && '20px',
    padding: hasPadding && '20px 17px 0',
    ...getBackground(),
  };
});

export const TitleContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'noBorderBottom' && prop !== 'noPaddingBottom',
})(({ theme, noBorderBottom, noPaddingBottom }) => ({
  borderBottom:
    !noBorderBottom && `1px solid ${theme.palette.colors.highlight}`,
  paddingBottom: !noPaddingBottom && '5px',
}));

export const TextStyled = styled(Typography)(({ theme }) => {
  return getTitleStyles(theme, false);
});

export const SelectStyled = styled(Select)(({ open, theme }) => ({
  border: 'none',
  minWidth: '187px',

  '&:focus': {
    border: 'none',
  },
  '& fieldset': {
    border: 'none',
  },
  '&:hover': {
    color: theme.palette.colors.highlight,
    '& svg': {
      color: theme.palette.colors.highlight,
    },
    '& .MuiSelect-select': {
      color: theme.palette.colors.highlight,
    },
  },
  '& svg': {
    color: theme.palette.colors.variantOnInfoBackground,
    '&.MuiSelect-iconOpen': {
      color: theme.palette.colors.highlight,
    },
  },

  '& .MuiSelect-select': {
    ...getTitleStyles(theme, open),
    padding: 0,
    backgroundColor: theme.palette.colors.primaryBackground,
    minHeight: 'auto',
  },
}));

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  height: '28px',
  padding: '0 14px 0 8px',
  fontSize: '12px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.variantOnPrimaryBackground,

  '& svg': {
    visibility: 'hidden',
  },
  '&:hover': {
    backgroundColor: theme.palette.colors.infoBackground,
  },
  '&.Mui-selected': {
    fontWeight: 'bold',
    backgroundColor: theme.palette.colors.primaryBackground,

    '&.Mui-focusVisible': { background: theme.palette.colors.infoBackground },
    '& svg': {
      visibility: 'visible',
    },
    '&:hover': {
      backgroundColor: theme.palette.colors.infoBackground,
    },
  },
}));

export const CheckIconStyled = styled(FontAwesomeIcon)(() => ({
  visibility: 'hidden',
}));

export const LabelStyled = styled('span')(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  marginBottom: theme.spacing(0.5),
  fontWeight: 'bold',
  '&.Mui-focused': {
    color: theme.palette.colors.mainFocused,
  },
  '&.Mui-disabled': {
    color: theme.palette.colors.secondaryDisabledText,
  },
}));
